<script>
    import {createEventDispatcher} from "svelte";

    export let items;
    export let value;

    const dispatch = createEventDispatcher();
    function onChange(e) {
        dispatch('change', {
            data: value,
        });
    }
</script>
<select
    bind:value={value}
    class="custom-dropdown"
    on:change={onChange}
>
    {#each Object.keys(items || {}) as key}
        <option value={items[key]}>{key}</option>
    {/each}
</select>